// file: src/utils/excelStyling.js
import * as XLSX from 'xlsx';
import { convertToExcelDate } from './excelDataFetcher';

// Fungsi untuk apply styling ke worksheet
export const applyExcelStyling = (ws, excelData) => {
  // Styling untuk header
  if (!ws['!merges']) ws['!merges'] = [];
  
  // Merge cells untuk header
  ws['!merges'].push(
    // Merge untuk "BIBIT" (G1-I1)
    { s: { r: 0, c: 6 }, e: { r: 0, c: 8 } },
    // Merge untuk "VARIETAS" (G2-G3)
    { s: { r: 1, c: 6 }, e: { r: 2, c: 6 } },
    // Merge untuk "KELAS" (H2-H3)
    { s: { r: 1, c: 7 }, e: { r: 2, c: 7 } },
    // Merge untuk "JENIS" (I2-I3)
    { s: { r: 1, c: 8 }, e: { r: 2, c: 8 } },
    // Merge untuk "TANGGAL PENGAMATAN" (A1-A3)
    { s: { r: 0, c: 0 }, e: { r: 2, c: 0 } },
    // Merge untuk "LOKASI" (D1-D3)
    { s: { r: 0, c: 3 }, e: { r: 2, c: 3 } },
    // Merge untuk "PLOT" (E1-E3)
    { s: { r: 0, c: 4 }, e: { r: 2, c: 4 } },
    // Merge untuk "STATUS" (F1-F3)
    { s: { r: 0, c: 5 }, e: { r: 2, c: 5 } },
    // Merge untuk "LUAS" (J1-J3)
    { s: { r: 0, c: 9 }, e: { r: 2, c: 9 } },
    // Merge untuk "AWAL RAWAT" (K1-K3)
    { s: { r: 0, c: 10 }, e: { r: 2, c: 10 } },
    // Merge untuk "PJP" (L1-L3)
    { s: { r: 0, c: 11 }, e: { r: 2, c: 11 } },
    
    // POPULASI - DIMULAI DARI N1-O1
    // Merge untuk "POPULASI" (N1-O1)
    { s: { r: 0, c: 13 }, e: { r: 0, c: 14 } },
    // Merge untuk "NORMAL" (N2-N3)
    { s: { r: 1, c: 13 }, e: { r: 2, c: 13 } },
    // Merge untuk "TOTAL" (O2-O3)
    { s: { r: 1, c: 14 }, e: { r: 2, c: 14 } },
    
    // FASE BUNGA NORMAL - DIMULAI DARI Q1-V1
    // Merge untuk "FASE BUNGA NORMAL" (Q1-V1)
    { s: { r: 0, c: 16 }, e: { r: 0, c: 21 } },
    // Merge untuk "OPEN HEART" (Q2-Q3)
    { s: { r: 1, c: 16 }, e: { r: 2, c: 16 } },
    // Merge untuk "RED BUD 1.25" (R2-R3)
    { s: { r: 1, c: 17 }, e: { r: 2, c: 17 } },
    // Merge untuk "RED BUD 2.54" (S2-S3)
    { s: { r: 1, c: 18 }, e: { r: 2, c: 18 } },
    // Merge untuk "EARLY CONES" (T2-T3)
    { s: { r: 1, c: 19 }, e: { r: 2, c: 19 } },
    // Merge untuk "MID CONES" (U2-U3)
    { s: { r: 1, c: 20 }, e: { r: 2, c: 20 } },
    // Merge untuk "LATE CONES" (V2-V3)
    { s: { r: 1, c: 21 }, e: { r: 2, c: 21 } },
    
    // FASE BUNGA ALAMI - DIMULAI DARI W1-AF1
    // Merge untuk "FASE BUNGA ALAMI" (W1-AF1)
    { s: { r: 0, c: 22 }, e: { r: 0, c: 31 } },
    // Merge untuk "EARLY PETALS" (W2-W3)
    { s: { r: 1, c: 22 }, e: { r: 2, c: 22 } },
    // Merge untuk "MID PETALS" (X2-X3)
    { s: { r: 1, c: 23 }, e: { r: 2, c: 23 } },
    // Merge untuk "LATE PETALS" (Y2-Y3)
    { s: { r: 1, c: 24 }, e: { r: 2, c: 24 } },
    // Merge untuk "DRY PETALS" (Z2-Z3)
    { s: { r: 1, c: 25 }, e: { r: 2, c: 25 } },
    // Merge untuk "FILLING STAGE 1" (AA2-AA3)
    { s: { r: 1, c: 26 }, e: { r: 2, c: 26 } },
    // Merge untuk "FILLING STAGE 2" (AB2-AB3)
    { s: { r: 1, c: 27 }, e: { r: 2, c: 27 } },
    // Merge untuk "SC0" (AC2-AC3)
    { s: { r: 1, c: 28 }, e: { r: 2, c: 28 } },
    // Merge untuk "SC0>" (AD2-AD3)
    { s: { r: 1, c: 29 }, e: { r: 2, c: 29 } },
    // Merge untuk "TERPETIK" (AE2-AE3)
    { s: { r: 1, c: 30 }, e: { r: 2, c: 30 } },
    // Merge untuk "DIMAKAN TIKUS" (AF2-AF3)
    { s: { r: 1, c: 31 }, e: { r: 2, c: 31 } },

    // BERBUNGA - AG1-AJ1
    // Merge untuk "BERBUNGA" (AG1-AJ1)
    { s: { r: 0, c: 32 }, e: { r: 0, c: 35 } },
    // Merge untuk "NORMAL" (AG2-AG3)
    { s: { r: 1, c: 32 }, e: { r: 2, c: 32 } },
    // Merge untuk "PENYAKIT" (AH2-AI2)
    { s: { r: 1, c: 33 }, e: { r: 1, c: 34 } },
    // Merge untuk "KERDIL" (AJ2-AJ3)
    { s: { r: 1, c: 35 }, e: { r: 2, c: 35 } },

    // BUAH ALAMI - AK1-AK3
    { s: { r: 0, c: 36 }, e: { r: 2, c: 36 } },
    // MATI - AL1-AL3
    { s: { r: 0, c: 37 }, e: { r: 2, c: 37 } },

    // MANDUL - AM1-AP1
    // Merge untuk "MANDUL" (AM1-AP1)
    { s: { r: 0, c: 38 }, e: { r: 0, c: 41 } },
    // Merge untuk "NORMAL" (AM2-AM3)
    { s: { r: 1, c: 38 }, e: { r: 2, c: 38 } },
    // Merge untuk "PENYAKIT" (AN2-AO2)
    { s: { r: 1, c: 39 }, e: { r: 1, c: 40 } },
    // Merge untuk "KERDIL" (AP2-AP3)
    { s: { r: 1, c: 41 }, e: { r: 2, c: 41 } },

    // TOTAL - AQ1-AQ3
    { s: { r: 0, c: 42 }, e: { r: 2, c: 42 } },
    // SPOT MATI - AR1-AR3
    { s: { r: 0, c: 43 }, e: { r: 2, c: 43 } },

    // PINGGIRAN - BERBUNGA - AS1-AV1
    // Merge untuk "BERBUNGA" (AS1-AV1)
    { s: { r: 0, c: 44 }, e: { r: 0, c: 47 } },
    // Merge untuk "NORMAL" (AS2-AS3)
    { s: { r: 1, c: 44 }, e: { r: 2, c: 44 } },
    // Merge untuk "PENYAKIT" (AT2-AU2)
    { s: { r: 1, c: 45 }, e: { r: 1, c: 46 } },
    // Merge untuk "KERDIL" (AV2-AV3)
    { s: { r: 1, c: 47 }, e: { r: 2, c: 47 } },

    // PINGGIRAN - BUAH ALAMI - AW1-AW3
    { s: { r: 0, c: 48 }, e: { r: 2, c: 48 } },
    // PINGGIRAN - MATI - AX1-AX3
    { s: { r: 0, c: 49 }, e: { r: 2, c: 49 } },

    // PINGGIRAN - MANDUL - AY1-BB1
    // Merge untuk "MANDUL" (AY1-BB1)
    { s: { r: 0, c: 50 }, e: { r: 0, c: 53 } },
    // Merge untuk "NORMAL" (AY2-AY3)
    { s: { r: 1, c: 50 }, e: { r: 2, c: 50 } },
    // Merge untuk "PENYAKIT" (AZ2-BA2)
    { s: { r: 1, c: 51 }, e: { r: 1, c: 52 } },
    // Merge untuk "KERDIL" (BB2-BB3)
    { s: { r: 1, c: 53 }, e: { r: 2, c: 53 } },

    // PINGGIRAN - TOTAL - BC1-BC3
    { s: { r: 0, c: 54 }, e: { r: 2, c: 54 } }
  );

  // Set column widths (diperluas hingga kolom BC)
  if (!ws['!cols']) ws['!cols'] = [];
  const colWidths = [
    { wch: 15 }, // A: Tanggal Pengamatan
    { wch: 5 },  // B: 
    { wch: 5 },  // C: 
    { wch: 10 }, // D: Lokasi
    { wch: 8 },  // E: Plot
    { wch: 10 }, // F: Status
    { wch: 12 }, // G: Varietas
    { wch: 8 },  // H: Kelas
    { wch: 8 },  // I: Jenis
    { wch: 8 },  // J: Luas
    { wch: 12 }, // K: Awal Rawat
    { wch: 8 },  // L: PJP
    { wch: 5 },  // M: (kosong)
    { wch: 10 }, // N: Populasi Normal
    { wch: 10 }, // O: Populasi Total
    { wch: 5 },  // P: (kosong)
    { wch: 12 }, // Q: Open Heart
    { wch: 12 }, // R: Red Bud 1.25
    { wch: 12 }, // S: Red Bud 2.54
    { wch: 12 }, // T: Early Cones
    { wch: 12 }, // U: Mid Cones
    { wch: 12 }, // V: Late Cones
    { wch: 12 }, // W: Early Petals
    { wch: 12 }, // X: Mid Petals
    { wch: 12 }, // Y: Late Petals
    { wch: 12 }, // Z: Dry Petals
    { wch: 12 }, // AA: Filling Stage 1
    { wch: 12 }, // AB: Filling Stage 2
    { wch: 8 },  // AC: SC0
    { wch: 8 },  // AD: SC0>
    { wch: 10 }, // AE: Terpetik
    { wch: 12 }, // AF: Dimakan Tikus
    { wch: 10 }, // AG: Berbunga Normal
    { wch: 8 },  // AH: Berbunga Phy
    { wch: 8 },  // AI: Berbunga Erw
    { wch: 10 }, // AJ: Berbunga Kerdil
    { wch: 12 }, // AK: Buah Alami
    { wch: 8 },  // AL: Mati
    { wch: 10 }, // AM: Mandul Normal
    { wch: 8 },  // AN: Mandul Phy
    { wch: 8 },  // AO: Mandul Erw
    { wch: 10 }, // AP: Mandul Kerdil
    { wch: 10 }, // AQ: Total
    { wch: 10 }, // AR: Spot Mati
    { wch: 10 }, // AS: Pinggiran Berbunga Normal
    { wch: 8 },  // AT: Pinggiran Berbunga Phy
    { wch: 8 },  // AU: Pinggiran Berbunga Erw
    { wch: 10 }, // AV: Pinggiran Berbunga Kerdil
    { wch: 12 }, // AW: Pinggiran Buah Alami
    { wch: 8 },  // AX: Pinggiran Mati
    { wch: 10 }, // AY: Pinggiran Mandul Normal
    { wch: 8 },  // AZ: Pinggiran Mandul Phy
    { wch: 8 },  // BA: Pinggiran Mandul Erw
    { wch: 10 }, // BB: Pinggiran Mandul Kerdil
    { wch: 10 }  // BC: Pinggiran Total
  ];
  ws['!cols'] = colWidths;

  // Format tanggal untuk kolom A (Tanggal Pengamatan) dan K (Awal Rawat)
  for (let row = 3; row < excelData.length; row++) {
    // Kolom A: Tanggal Pengamatan
    const cellAddressA = XLSX.utils.encode_cell({ r: row, c: 0 });
    if (ws[cellAddressA] && ws[cellAddressA].v !== '-' && ws[cellAddressA].v !== '') {
      // Set format number untuk tanggal
      ws[cellAddressA].z = 'dd/mm/yyyy';
      
      // Konversi string ke Excel serial number untuk sorting
      if (typeof ws[cellAddressA].v === 'string') {
        const dateStr = ws[cellAddressA].v;
        const [day, month, year] = dateStr.split('/');
        if (day && month && year) {
          const date = new Date(Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)));
          const excelEpoch = new Date(Date.UTC(1899, 11, 30));
          const diffDays = (date - excelEpoch) / (1000 * 60 * 60 * 24);
          
          ws[cellAddressA].v = diffDays;
          ws[cellAddressA].t = 'n';
        }
      }
    }

    // Kolom K: Awal Rawat
    const cellAddressK = XLSX.utils.encode_cell({ r: row, c: 10 });
    if (ws[cellAddressK] && ws[cellAddressK].v !== '-' && ws[cellAddressK].v !== '') {
      // Set format number untuk tanggal
      ws[cellAddressK].z = 'dd/mm/yyyy';
      
      // Konversi string ke Excel serial number untuk sorting
      if (typeof ws[cellAddressK].v === 'string') {
        const dateStr = ws[cellAddressK].v;
        const [day, month, year] = dateStr.split('/');
        if (day && month && year) {
          const date = new Date(Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)));
          const excelEpoch = new Date(Date.UTC(1899, 11, 30));
          const diffDays = (date - excelEpoch) / (1000 * 60 * 60 * 24);
          
          ws[cellAddressK].v = diffDays;
          ws[cellAddressK].t = 'n';
        }
      }
    }
  }

  // Format number untuk kolom J (Luas) - dengan 2 digit desimal
  for (let row = 3; row < excelData.length; row++) {
    const cellAddressJ = XLSX.utils.encode_cell({ r: row, c: 9 });
    if (ws[cellAddressJ] && ws[cellAddressJ].v !== null && ws[cellAddressJ].v !== undefined) {
      ws[cellAddressJ].t = 'n';
      ws[cellAddressJ].z = '0.00'; // Format dengan 2 digit desimal
    }
  }

  // Format integer untuk kolom N sampai BC (Populasi sampai Pinggiran Total)
  for (let row = 3; row < excelData.length; row++) {
    // Kolom N sampai BC (13 sampai 54)
    const integerColumns = [];
    for (let col = 13; col <= 54; col++) {
      integerColumns.push(col);
    }
    
    integerColumns.forEach(col => {
      const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
      if (ws[cellAddress] && ws[cellAddress].v !== null && ws[cellAddress].v !== undefined) {
        ws[cellAddress].t = 'n';
        ws[cellAddress].z = '0'; // Format tanpa digit desimal
      }
    });
  }
  
  // Styling untuk header (opsional - untuk membuat header lebih menarik)
  const headerStyle = {
    font: { bold: true, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "4472C4" } },
    alignment: { horizontal: "center", vertical: "center" }
  };
  
  // Apply style ke header rows (0, 1, 2)
  for (let row = 0; row < 3; row++) {
    for (let col = 0; col < excelData[0].length; col++) {
      const cellAddr = XLSX.utils.encode_cell({ r: row, c: col });
      if (!ws[cellAddr]) ws[cellAddr] = {};
      ws[cellAddr].s = headerStyle;
    }
  }

};